import type { VFXNodeDefinition } from '../../types';
/**
 * @engine/vfx — operator node pack (sliced by category).
 */
import { MATH_NODES } from './math';
import { RANDOM_NODES } from './random';
import { NOISE_NODES } from './noise';
import { ATTRIBUTE_NODES } from './attributes';
import { TIME_NODES } from './time';
import { SAMPLING_NODES } from './sampling';
import { CONVERSION_NODES } from './conversion';
import { POINTMAP_NODES } from './pointMap';

export const OPERATOR_NODES: readonly VFXNodeDefinition[] = [
  ...MATH_NODES,
  ...RANDOM_NODES,
  ...NOISE_NODES,
  ...ATTRIBUTE_NODES,
  ...TIME_NODES,
  ...SAMPLING_NODES,
  ...CONVERSION_NODES,
  ...POINTMAP_NODES,
];
